import {AbstractView} from "../../../views/AbstractView";
import {
  IT_USER_AVATAR_CONTROLLER, IUserAvatarController,
  MK_USER_AVATAR_INPUT_CONFIG,
} from "../_controllers/IUserAvatarController";
import {
  Component,
  effect,
  ElementRef,
  inject,
  input,
  Renderer2,
  untracked,
  ViewChild,
  ViewEncapsulation
} from "@angular/core";
import {UserAvatarInputConfigModel} from "../_models/UserAvatarInputConfigModel";
import {StandardUserAvatarController} from "../_controllers/standard-user-avatar.controller";
import {ControllerEventBus} from "../../../event-buses/controller.event-bus";

@Component({
  selector: 'link-user-avatar',
  templateUrl: './user-avatar.view.html',
  styleUrls: ['./user-avatar.view.scss'],
  providers: [
    { provide: IT_USER_AVATAR_CONTROLLER, useClass: StandardUserAvatarController }
  ],
})
export class UserAvatarView extends AbstractView<IUserAvatarController>  {

  protected readonly model: UserAvatarInputConfigModel;
  private readonly renderer: Renderer2;

  readonly userId = input<number>();
  readonly size = input<number>();

  @ViewChild('initialsAvatar', { static: false })
  initialsAvatar: ElementRef | undefined;

  @ViewChild('initialsAvatarString', { static: false })
  initialsAvatarString!: ElementRef<HTMLSpanElement>;

  constructor() {
    super(IT_USER_AVATAR_CONTROLLER);
    this.renderer = inject(Renderer2);

    this.model = this.getController().getModel(MK_USER_AVATAR_INPUT_CONFIG);

    effect(() => {
      const userId = this.userId();
      const size = this.size();

      untracked(() => {
        this.getController().handle('ConfigOverwrite', {
          userId: userId,
          size: size,
        });
      });
    }, {allowSignalWrites: true});

    effect(() => {
      if (!this.model.avatar$()) {
        setTimeout(() => {
          this.updateSize();
        });
      }
    });

  }

  updateSize() {
    if(this.initialsAvatar && this.initialsAvatarString) {
       let height = 40;
        if(this.model.size$()) {
          height = this.model.size$()!;
        }
        this.renderer.setProperty(this.initialsAvatar!.nativeElement.style, 'width', height + 'px');
        this.renderer.setProperty(this.initialsAvatar!.nativeElement.style, 'height', height + 'px');
        this.renderer.setProperty(this.initialsAvatarString!.nativeElement.style, 'line-height', height + 'px');
        this.renderer.setProperty(this.initialsAvatarString!.nativeElement.style, 'font-size', (height / 2) + 'px');
      }
  }
}
